import React from 'react';

export const Terms = () => {
  return (
    <div className="w-full">
      <h2 className="mb-3 text-left">
        <b>Terms and Conditions</b>
      </h2>
      <p className="mb-5 text-left">
        <b>Last Modified:</b> October 8, 2024
      </p>
      <p className="mb-5 text-left">
        Welcome to <a href="https://tytum.com">tytum.com</a>{' '}
        (&ldquo;Website&ldquo;), operated by Tytum (&ldquo;we,&ldquo;
        &ldquo;us,&ldquo; or &ldquo;our&ldquo;). By accessing or using our
        Website, you agree to comply with and be bound by the following Terms
        and Conditions (&ldquo;Terms&ldquo;). Please read these Terms carefully
        before using the Website. If you do not agree to these Terms, you must
        not use our Website.
      </p>
      <h3 className="text-left text-lg font-bold">1. Use of the Website</h3>
      <p className="mb-5 text-left">
        You agree to use the Website only for lawful purposes and in accordance
        with these Terms. You must not:
      </p>
      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          Use the Website in any way that violates any applicable federal,
          state, local, or international law or regulation.
        </li>
        <li className="text-left">
          Engage in any conduct that restricts or inhibits anyone’s use or
          enjoyment of the Website or may harm us or other users of the Website.
        </li>
        <li className="text-left">
          Attempt to gain unauthorized access to any portion of the Website,
          other accounts, computer systems, or networks connected to the
          Website.
        </li>
      </ul>

      <h3 className="text-left text-lg font-bold">
        2. Intellectual Property Rights
      </h3>
      <p className="mb-5 text-left">
        All content on the Website, including text, graphics, logos, images, and
        software, is the property of Tytum or its licensors and is protected by
        United States and international copyright, trademark, and other
        intellectual property laws. You may not reproduce, distribute, modify,
        or create derivative works of any content on the Website without our
        express written consent.
      </p>
      <h3 className="text-left text-lg font-bold">3. User Content</h3>
      <p className="mb-5 text-left">
        You may have the opportunity to post, submit, or otherwise make
        available content (&ldquo;User Content&ldquo;) on the Website. By
        posting User Content, you grant us a non-exclusive, worldwide,
        royalty-free, perpetual, and irrevocable license to use, display,
        reproduce, and distribute your User Content in connection with the
        Website.
      </p>
      <p className="mb-5 text-left">
        You are solely responsible for your User Content and must ensure that it
        does not:
      </p>
      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          Infringe any third party’s intellectual property rights.
        </li>
        <li className="text-left">
          Contain offensive, harmful, or illegal material.
        </li>
        <li className="text-left">Violate any laws or regulations.</li>
      </ul>
      <p className="mb-5 text-left">
        We reserve the right to remove any User Content that we believe violates
        these Terms or is otherwise objectionable.
      </p>
      <h3 className="text-left text-lg font-bold">
        4. Third-Party Links and Services
      </h3>
      <p className="mb-5 text-left">
        The Website may contain links to third-party websites or services that
        are not owned or controlled by Tytum. We have no control over and assume
        no responsibility for, the content, privacy policies, or practices of
        any third-party websites or services. You access third-party websites at
        your own risk, and we encourage you to review the terms and conditions
        and privacy policies of any third-party websites you visit.
      </p>
      <h3 className="text-left text-lg font-bold">5. Privacy Policy</h3>
      <p className="mb-5 text-left">
        Your use of the Website is also governed by our Privacy Policy. Please
        review the Privacy Policy to understand how we collect, use, and
        disclose your personal information.
      </p>
      <h3 className="text-left text-lg font-bold">
        6. Disclaimer of Warranties
      </h3>
      <p className="mb-5 text-left">
        The Website is provided &ldquo;as is&ldquo; and &ldquo;as
        available&ldquo; without any warranties of any kind, either express or
        implied, including, but not limited to, warranties of merchantability,
        fitness for a particular purpose, and non-infringement. We do not
        warrant that the Website will be uninterrupted, error-free, secure, or
        free from viruses or other harmful components.
      </p>
      <h3 className="text-left text-lg font-bold">
        7. Limitation of Liability
      </h3>
      <p className="mb-5 text-left">
        To the maximum extent permitted by law, Tytum, its affiliates,
        licensors, and service providers shall not be liable for any indirect,
        incidental, special, consequential, or punitive damages arising out of
        or related to your use of or inability to use the Website, even if we
        have been advised of the possibility of such damages. Our total
        liability to you for any damages, regardless of the form of action, will
        not exceed the amount paid by you, if any, for accessing the Website.
      </p>
      <h3 className="text-left text-lg font-bold">8. Indemnification</h3>
      <p className="mb-5 text-left">
        You agree to indemnify, defend, and hold harmless Tytum, its officers,
        directors, employees, and agents from and against any claims,
        liabilities, damages, judgments, awards, losses, costs, expenses, or
        fees (including reasonable attorneys&quot; fees) arising out of or
        relating to your violation of these Terms or your use of the Website.
      </p>
      <h3 className="text-left text-lg font-bold">
        9. Governing Law and Jurisdiction
      </h3>
      <p className="mb-5 text-left">
        These Terms shall be governed by and construed in accordance with the
        laws of the State of California, without regard to its conflict of law
        principles. Any legal action or proceeding arising under these Terms
        shall be brought exclusively in the federal or state courts located in
        San Diego County, California, and you hereby consent to the jurisdiction
        and venue of such courts.
      </p>
      <h3 className="text-left text-lg font-bold">10. Changes to the Terms</h3>
      <p className="mb-5 text-left">
        We reserve the right to modify or update these Terms at any time. Any
        changes will be effective immediately upon posting to the Website. Your
        continued use of the Website following the posting of revised Terms
        means that you accept and agree to the changes.
      </p>
      <h3 className="text-left text-lg font-bold">11. Termination</h3>
      <p className="mb-5 text-left">
        We may terminate or suspend your access to the Website at any time,
        without prior notice or liability, for any reason whatsoever, including,
        without limitation, if you breach these Terms.
      </p>
      <h3 className="text-left text-lg font-bold">12. Contact Information</h3>
      <p className="mb-1 text-left">
        If you have any questions or concerns about these Terms, please contact
        us at:
      </p>
      <p className="mb-1 text-left">Email: contact@tytum.com</p>
      <p className="mb-1 text-left">Phone: 619-349-4397</p>
      <p className="mb-1 text-left">
        Address: 16950 Via De Santa Fe, Suite 5060-136, Rancho Santa Fe, CA
        92091
      </p>
    </div>
  );
};
